module.exports = __webpack_public_path__ + "static/5-4511ce2f8d496b07bd6b4034699d8d3c.png";